import { AbstractControl } from '@angular/forms';

export function validatePassword(control: AbstractControl): 
                                { [key: string]: boolean } | null 
{
    return null;            
}    
